import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AutofocusDirective} from '../../autofocus.directive';
import { ClientRepresentativesService } from 'src/app/api/services';
import { ClientRepresentative } from 'src/app/api/models';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-client-representative-page',
  templateUrl: './client-representative-page.component.html',
  styleUrls: ['./client-representative-page.component.scss']
})
export class ClientRepresentativePageComponent implements OnInit, OnDestroy {
  private readonly ngDestroy$ = new Subject();

  clientRepresentative: ClientRepresentative;
  clientRepresentative$ = new ReplaySubject<ClientRepresentative>();
  form: UntypedFormGroup;
  editMode = false;

  @ViewChild(AutofocusDirective) focus: AutofocusDirective;

  constructor(private builder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private clientRepresentativesService: ClientRepresentativesService) {
    this.form = this.builder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required]
    });
  }

  editClientRepresentative() {
    this.editMode = true;
    this.focus.focus();
  }

  revertClientRepresentative(rep: ClientRepresentative) {
    if (!rep.id) {
      this.router.navigate(['/clients', rep.client_id]);
    }
    this.clientRepresentative$.next(rep);
    this.editMode = false;
  }

  saveClientRepresentative(rep: ClientRepresentative) {
    Object.assign(rep, this.form.value);

    let createOrUpdate = this.clientRepresentativesService.createClientRepresentative({client_id: rep.client_id, body: rep});
    if (rep.id) {
      createOrUpdate = this.clientRepresentativesService.updateClientRepresentative({client_id: rep.client_id, id: rep.id, body: rep});
    }
    createOrUpdate.pipe(take(1)).subscribe(clientRep => {
      this.clientRepresentative$.next(clientRep);
      this.editMode = false;
    });
  }

  ngOnInit() {
    this.route.paramMap.pipe(takeUntil(this.ngDestroy$))
    .subscribe((params: ParamMap) => {
      if (params.has('clientRepresentativeId')) {
        this.clientRepresentativesService.getClientRepresentative({client_id: +params.get('clientId'), id: +params.get('clientRepresentativeId')})
        .subscribe(clientRepresentative => {
          this.clientRepresentative$.next(clientRepresentative);
        });
      } else {
        const newRep = <ClientRepresentative>{};
        newRep.client_id = +params.get('clientId');
        this.clientRepresentative$.next(newRep);
        this.editMode = true;
      }
    });

    // keep form values in sync
    this.clientRepresentative$.pipe(takeUntil(this.ngDestroy$))
    .subscribe(rep => {
      this.form.patchValue(rep);
    });
  }

  ngOnDestroy() {
    this.ngDestroy$.next(undefined);
    this.ngDestroy$.complete();
  }
}
